import React, { useEffect, useState, useRef } from "react"
import {
  Card,
  Form,
  CardBody,
  CardSubtitle,
  Container,
  Spinner,
  Progress,
  Button,
} from "reactstrap"
import Dropzone from "react-dropzone"
import moment from "moment"
import helper from "helpers/fn_helper"
import { UploadFile } from "services/api/module/Upload"
import { UploadFileToS3, DeleteFileFromS3 } from "services/api/module/UploadS3"
import fn_helper from "helpers/fn_helper"

const UploadFileAPI = ({
  label = "Dropzone",
  description = "description",
  onChange = () => console.log("onChange!"),
  prefixName = "broadcast",
  value = null,
  upload = "Image",
  typeUpload = "",
  widthSize = 0,
  heightSize = 0,
  isEditMode = false, // New prop to check if we're in edit mode
}) => {
  const [firstLoad, setFirstLoad] = useState(false)
  const [fileData, setFileData] = useState(null)
  const [fileURL, setFileURL] = useState(null)
  const [imageSize, setImageSize] = useState(null)
  const [loadingImage, setLoadingImage] = useState(false)
  const [loadingAudio, setLoadingAudio] = useState(false)

  // New states for audio upload progress and cancellation
  const [uploadProgress, setUploadProgress] = useState(0)
  const [isUploading, setIsUploading] = useState(false)
  const abortControllerRef = useRef(null)
  const uploadIdRef = useRef(null)

  async function handleAcceptedFiles(files) {
    if (isEditMode && upload === "Audio" && value) {
      return
    }

    console.log("🚀 ~ handleAcceptedFiles ~ files:", files)
    const _fileData = files[0]
    const tmpfilename = _fileData?.name ?? ".png"
    const typeSplit = `${tmpfilename}`.split(".")
    // Modified: Convert file extension to lowercase for case-insensitive comparison
    const typeFile = typeSplit[typeSplit.length - 1].toLowerCase()
    console.log(typeFile)

    const fileSize = _fileData.size
    const sizeInMB = fileSize / 1024 / 1024 // Convert bytes to MB

    let updateImageSize = "0x0"

    let CONF_FILE_TYPE = ["png", "jpg", "jpeg"]
    let CONF_FILE_SIZE = 10
    let JOIN = ", "
    // upload = "Image"
    if (upload == "Video") {
      CONF_FILE_TYPE = ["mp4"]
      CONF_FILE_SIZE = 50
      JOIN = ""

      // setFileURL(URL.createObjectURL(files[0]));
      setFileData(files[0])
    }

    if (upload == "Audio") {
      CONF_FILE_TYPE = ["wav"] // This will now match both "wav" and "WAV" due to toLowerCase() above
      JOIN = ""
      if (CONF_FILE_TYPE.includes(typeFile)) {
        setFileURL(URL.createObjectURL(files[0]))
        setFileData(files[0])
      } else {
        alert(`File type ${CONF_FILE_TYPE.join(JOIN)} only`)
      }
    }

    if (upload == "Image") {
      if (CONF_FILE_TYPE.includes(typeFile)) {
        const { width, height } = await helper.FNFILE.getImageDimensions(
          _fileData
        )
        updateImageSize = `${width}x${height}`

        if (typeUpload == "ImageMap") {
          let minSize = 1024
          console.log(
            "🚀 ~ handleAcceptedFiles ~ width, height:",
            width,
            height
          )
          console.log("🚀 ~ handleAcceptedFiles ~ 1", width >= minSize)
          console.log("🚀 ~ handleAcceptedFiles ~ 2", height >= minSize)
          console.log("🚀 ~ handleAcceptedFiles ~ 3", width == height)
          if (!(width == widthSize && height == heightSize)) {
            alert(`File resolution ${widthSize} x ${heightSize}`)
            return
          }
        }

        if (sizeInMB <= CONF_FILE_SIZE) {
          // setFileURL(URL.createObjectURL(files[0]))
          setFileData(files[0])
          setImageSize(updateImageSize)
        } else {
          alert(`File size max ${CONF_FILE_SIZE} MB`)
        }
      } else {
        alert(`File type ${CONF_FILE_TYPE.join(JOIN)} only`)
      }
    }
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const handleCancelUpload = async () => {
    try {
      if (uploadIdRef.current && abortControllerRef.current) {
        // Cancel the fetch request if it's in progress
        abortControllerRef.current.abort()

        // Abort the multipart upload on S3
        const bucketName = "internal-chatbot-storage"
        const key = `audio/${uploadIdRef.current.filename}`

        console.log("Aborting multipart upload", {
          bucketName,
          key,
          uploadId: uploadIdRef.current.id,
        })

        // Reset all states
        setIsUploading(false)
        setUploadProgress(0)
        setLoadingAudio(false)
        setFileData(null)
        setFileURL(null) // Clear the file URL to prevent showing the file
        setFirstLoad(false)
        abortControllerRef.current = null
        uploadIdRef.current = null

        // Alert user
        alert("Upload was cancelled")
      }
    } catch (error) {
      console.error("Error cancelling upload:", error)
    }
  }

  const uploadFile = async (_fileData = {}) => {
    const tmpfilename = _fileData?.name ?? ".png"
    const tmpTypeFile = `${tmpfilename}`.split(".")
    const typeFile = tmpTypeFile[tmpTypeFile.length - 1]

    const timestamp = moment().unix()
    let fileName = `${prefixName}-${timestamp}.${typeFile}`

    if (upload !== "Audio") {
      setLoadingImage(true)
      const FILE_LINK = await fetchUploadFileGeneric(_fileData, fileName, false)
      setTimeout(() => setLoadingImage(false), 100)

      console.log("🚀 ~ uploadFile ~ FILE_LINK:", FILE_LINK)
      if (FILE_LINK) {
        onChange([FILE_LINK, imageSize])
      }
    } else {
      setLoadingAudio(true)
      setIsUploading(true)
      setUploadProgress(0)

      // Create new AbortController for this upload
      abortControllerRef.current = new AbortController()

      const originalName = _fileData.name.split(".")[0] // ชื่อไฟล์เดิมไม่รวมนามสกุล
      const formattedDate = moment().format("DDMMYYYY_HHmmss") // รูปแบบวันที่และเวลา
      fileName = `${originalName}_${formattedDate}.${typeFile}`

      const FILE_LINK = await fetchUploadFileGeneric(
        _fileData,
        fileName,
        true,
        progress => {
          setUploadProgress(progress)
        },
        abortControllerRef.current
      )

      setLoadingAudio(false)
      setIsUploading(false)

      if (FILE_LINK) {
        onChange([FILE_LINK, fileName])
      }
    }
  }

  const fetchUploadFileGeneric = async (
    selectedFile,
    fileName = "",
    isAudio = false,
    onProgress = null,
    abortController = null
  ) => {
    const formData = new FormData()
    formData.append("file", selectedFile)

    return new Promise(async (resolve, reject) => {
      try {
        // For audio files, use S3 upload with progress
        if (isAudio) {
          const timestamp = moment().unix()
          const finalFileName = fileName || `audio-${timestamp}.${typeFile}`

          // Send with progress tracking
          const result = await UploadFileToS3({
            file: selectedFile,
            folder: "audio",
            fileName: finalFileName,
            onProgress: onProgress,
            abortController: abortController,
            onUploadIdGenerated: uploadId => {
              // Store the upload ID for potential cancellation
              uploadIdRef.current = {
                id: uploadId,
                filename: finalFileName,
              }
            },
          })

          if (result.success) {
            console.log("Successfully uploaded audio to S3:", result.url)
            resolve(result.url)
          } else if (result.aborted) {
            console.log("Upload was aborted by user")
            resolve(null) // Return null when aborted
          } else {
            console.error("Failed to upload audio to S3:", result.error)
            throw new Error(result.error || "Failed to upload audio to S3")
          }
        }
        // For image files, use actual API
        else {
          const response = await UploadFile({
            formData: formData,
            bucketName: "banner",
            fileName: fileName,
          })

          const resData = response.data
          if (resData.status === 201) {
            console.log("resData >>", resData)
            let fetching = true
            while (fetching) {
              try {
                const resImg = await fetch(resData?.data?.url) // Fetch Data Free
                console.log("🚀 ~ returnnewPromise ~ resImg:", resImg)
                fetching = false
                break
              } catch (e) {
                console.log("e fetch img", e)
              }
              await fn_helper.FN.delayTime(500)
            }
            resolve(resData?.data?.url ?? null)
          }
        }
      } catch (e) {
        console.log(e)
        if (e.name === "AbortError") {
          console.log("Upload was aborted")
        }
        resolve(null)
        if (e.name !== "AbortError") {
          alert(
            isAudio
              ? "เกิดข้อผิดพลาดในการอัพโหลดไฟล์เสียง"
              : "Something went wrong"
          )
        }
      }
    })
  }

  const onClearState = async () => {
    // If in edit mode and it's an audio file, don't allow deletion
    if (isEditMode && upload === "Audio" && value) {
      return
    }

    try {
      // If we have a file URL and it's an audio file, try to delete it from S3
      if (fileURL && upload === "Audio") {
        console.log("Attempting to delete audio file from S3:", fileURL)
        const deleteResult = await DeleteFileFromS3({
          fileUrl: fileURL,
          bucketName: "internal-chatbot-storage",
        })

        if (deleteResult.success) {
          console.log("Successfully deleted file from S3")
        } else {
          console.error("Failed to delete file from S3:", deleteResult.error)
        }
      }
    } catch (error) {
      console.error("Error during file deletion:", error)
    } finally {
      // Reset all states regardless of whether deletion succeeded
      setFileData(null)
      setFileURL(null)
      setFirstLoad(false)
      setUploadProgress(0)
      setIsUploading(false)
      onChange(["", ""])
    }
  }

  useEffect(() => {
    if (fileData) {
      uploadFile(fileData)
    }
  }, [fileData])

  // Track upload state for UI updates
  useEffect(() => {
    // Update isUploading based on loadingAudio
    if (upload === "Audio") {
      setIsUploading(loadingAudio)
    }
  }, [loadingAudio, upload])

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ value:", value)

    if (value) {
      setFileURL(value)
      setFirstLoad(true)
    } else {
      onClearState()
    }
  }, [value])

  let acceptFile = { "image/png": [".png"], "image/jpeg": [".jpg", ".jpeg"] }
  description = "File type png, jpg, jpeg only, Max filesize 10 MB "
  if (upload == "Video") {
    acceptFile = { "video/*": [".mp4"] }
    description = "File type mp4 only, Max file size 50 MB"
  }
  if (upload == "Audio") {
    acceptFile = { "audio/wav": [".wav", ".WAV"] }
    description = "File type wav only"
  }
  if (typeUpload == "ImageMap") {
    description = `File type png, jpg, jpeg only, Max filesize 10 MB`
    if (widthSize) {
      description += `, File resolution `
      description += `${widthSize} x `
    }
    if (heightSize) {
      description += `${heightSize}`
    }
  }

  return (
    <React.Fragment>
      <Card>
        <div>
          {upload == "Image" && <h6 className="card-title">{label}</h6>}
          {upload == "Image" && (
            <CardSubtitle className="mb-3">{description}</CardSubtitle>
          )}
          <Form>
            {fileData || firstLoad ? (
              <>
                {upload === "Image" ? (
                  <div className="dropzone bImageBox">
                    {loadingImage ? (
                      <Spinner
                        color="primary"
                        className="position-absolute top-50 start-50"
                      />
                    ) : (
                      <img data-dz-thumbnail="" src={fileURL} />
                    )}
                  </div>
                ) : upload === "Video" ? (
                  <div className="dropzone bImageBox">
                    <div className="bVideoUpload">
                      <div className="bx bx-video-recording bx-lg"></div>
                      <h4>Video File</h4>
                    </div>
                  </div>
                ) : upload === "Audio" ? (
                  <div className="dropzone bImageBox align-items-center d-flex justify-content-center">
                    {loadingAudio ? (
                      <div className="d-flex flex-column w-100 p-3">
                        <div className="mb-2 text-center">
                          <span>Uploading {uploadProgress.toFixed(0)}%</span>
                        </div>
                        <Progress
                          value={uploadProgress}
                          className="mb-3"
                          striped={uploadProgress < 100}
                          animated={uploadProgress < 100}
                        />
                        <div className="d-flex justify-content-center">
                          <Spinner color="primary" size="sm" />
                        </div>
                      </div>
                    ) : (
                      <div className="bAudioUpload d-flex flex-column justify-content-center align-items-center ">
                        <div className="bx bx-music bx-lg"></div>
                        <h4>Audio File</h4>
                        {fileURL && (
                          <div className="mt-3">
                            <audio
                              controls
                              src={fileURL}
                              className="w-full max-w-xs"
                            >
                              Your browser does not support the audio element.
                            </audio>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <>NULL</>
                )}
                {upload === "Audio" && isUploading ? (
                  <div className="mt-4">
                    <button
                      type="button"
                      className="btn btn-danger "
                      onClick={handleCancelUpload}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  !(isEditMode && upload === "Audio" && value) && (
                    <div className="mt-4">
                      <button
                        type="button"
                        className="btn btn-danger "
                        onClick={onClearState}
                      >
                        Delete
                      </button>
                    </div>
                  )
                )}
              </>
            ) : (
              <>
                {upload === "Audio" && isEditMode ? (
                  <Dropzone disabled>
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone">
                        <div
                          className="dz-message needsclick mt-2"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-file-x" />
                          </div>
                          <h4>File not available or No file uploaded</h4>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                ) : (
                  <Dropzone
                    onDrop={acceptedFiles => {
                      handleAcceptedFiles(acceptedFiles)
                    }}
                    accept={acceptFile}
                    multiple={false}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone">
                        <div
                          className="dz-message needsclick mt-2"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h4>Drop {upload} file here or click to upload.</h4>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                )}
              </>
            )}
          </Form>
        </div>
      </Card>
    </React.Fragment>
  )
}

export default UploadFileAPI
